import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NewsAdmin from '../views/NewsAdmin.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/admin/news', name: 'NewsAdmin', component: NewsAdmin, meta: { admin: true } }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' }
    }
    return savedPosition || { x: 0, y: 0 }
  }
})

export default router
